import {take, put} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes} from '@ace-de/eua-entity-types';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import * as sasdActionTypes from '../sasdActionTypes';

/**
 * Update SASD damage location info
 */
const updateSASDDamageLocationInfo = function* updateSASDDamageLocationInfo() {
    while (true) {
        const {payload} = yield take(sasdActionTypes.SUBMIT_SASD_DAMAGE_LOCATION_INFO_FORM);
        const {serviceCaseData, serviceCaseId, serviceAssignmentData, serviceAssignmentLineNo, caseType} = payload;

        if (serviceCaseData) {
            yield* updateServiceCase({
                caller: sasdActionTypes.SUBMIT_SASD_DAMAGE_LOCATION_INFO_FORM,
                caseType: caseType,
                serviceCaseId,
                serviceCaseData,
            });
        }

        yield* updateServiceAssignment({
            caller: sasdActionTypes.SUBMIT_SASD_DAMAGE_LOCATION_INFO_FORM,
            assignmentType: efServiceAssignmentTypes.SUBSTITUTE_DRIVER,
            serviceCaseId,
            serviceAssignmentLineNo,
            serviceAssignmentData,
        });

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: sasdActionTypes.SUBMIT_SASD_DAMAGE_LOCATION_INFO_FORM},
        });
    }
};

export default updateSASDDamageLocationInfo;
